module.exports = __webpack_public_path__ + "img/cardGallery2.jpg?7c69cd42d34a29fa76f324c453e936bd";